export default __webpack_public_path__ + "static/media/about-1.fe94771f.jpg";